module.exports = __webpack_public_path__ + "media/images/freshchat-6cc16b05a2b59312f22d8029579f9654.svg";